// finds the intersection of two sorted arrays.
// result is sorted too
export function sortedArrayIntersection(a, b) {
	let result = [];
	let i = 0,
		j = 0;
	while (i < a.length && j < b.length) {
		if (a[i] === b[j]) {
			result.push(a[i]);
			i++;
			j++;
		} else if (a[i] < b[j]) {
			i++;
		} else {
			j++;
		}
	}
	return result;
}

// returns true if the sorted array has the value
export function sortedArrayHas(list, value) {
	return sortedArrayIndexOf(list, value) >= 0;
}

export function sortedArrayIndexOf(list, value) {
	let i = 0;
	let j = list.length - 1;
	while (i <= j) {
		let m = (i + j) >> 1;
		if (list[m] === value) {
			return m;
		} else if (list[m] < value) {
			i = m + 1;
		} else {
			j = m - 1;
		}
	}
	return -1;
}

// comparator for sorting numbers
export function compareNumbers(a, b) {
	return a - b;
}

// Assumes ordered and unique arrays, returns ordered unique union of both.
export function sortedArrayUnion(a, b) {
	const result = [];
	let i = 0,
		j = 0;
	while (i < a.length && j < b.length) {
		if (a[i] === b[j]) {
			result.push(a[i]);
			i++;
			j++;
		} else if (a[i] < b[j]) {
			result.push(a[i]);
			i++;
		} else {
			result.push(b[j]);
			j++;
		}
	}

	for (; i < a.length; i++) result.push(a[i]);
	for (; j < b.length; j++) result.push(b[j]);

	return result;
}